const isSearchBarValueEmpty = (value) => value.query.length === 0 && (value.filters.length === 0 || value.filters.every((f) => f.value === null)) && !value.imageUrl && !value.color && !value.similarToResource;

export { isSearchBarValueEmpty };
//# sourceMappingURL=isSearchBarValueEmpty.js.map
